import { render, staticRenderFns } from "./Stars.vue?vue&type=template&id=62281d88&scoped=true&"
import script from "./Stars.vue?vue&type=script&lang=ts&"
export * from "./Stars.vue?vue&type=script&lang=ts&"
import style0 from "./Stars.vue?vue&type=style&index=0&id=62281d88&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62281d88",
  null
  
)

export default component.exports